import type { JSX } from 'react';

export function ChoiceGroup<T extends string>({
  label,
  value,
  options,
  disabled,
  onChange,
}: {
  label: string;
  value: T | null;
  options: readonly { id: T; label: string }[];
  disabled?: boolean;
  onChange: (id: T) => void;
}): JSX.Element {
  return (
    <div className={`btn-group${options.length >= 5 ? ' btn-group-dense' : ''}`} role="radiogroup" aria-label={label}>
      {options.map((item) => {
        const on = item.id === value;
        return (
          <button
            key={item.id}
            type="button"
            role="radio"
            aria-checked={on}
            disabled={disabled}
            className={`btn-group-item${on ? ' btn-group-item-on' : ''}`}
            onClick={() => onChange(item.id)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
